import {useState} from "react";
import {saveMileage} from "../services/api";

export function Car() {
    const [mileage, setMileage] = useState(0)
    const [message, setMessage] = useState("")
    const updateMileage = (event) => {
        setMileage(parseInt(event.target.value))
    }
    
    const submit = async(event) => {
        event.preventDefault();
        try {
            await saveMileage(mileage);
            setMessage("mileage updated")
        } catch (ex) {
            console.log("Error updating mileage")
        }
    }
    
    return (
        <>
            {message && <div className={"alert alert-info"}>
                <span>{message}</span>
            </div>}

            <form onSubmit={submit}>
                <div className="form-group mb-3">
                    <label>New Mileage</label>
                    <input type="text" className="form-control" value={mileage} onChange={updateMileage}/>
                </div>
                <div className="form-group">
                    <button className="btn btn-primary">Submit</button>
                </div>
            </form>
        </>
    )
}